var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 128,
    viewBox: "0 0 128 128",
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.61 65.36c0-4.29-.4-8.41-1.1-12.36H64v22.98h32.33c-1.34 7.62-5.56 14.12-12.01 18.45v15.09h19.44c11.33-10.45 17.85-25.89 17.85-44.16z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 124c16.19 0 29.83-5.32 39.76-14.48L84.32 94.43c-5.36 3.6-12.26 5.71-20.32 5.71-15.61 0-28.86-10.53-33.59-24.73H10.39v15.53C20.26 110.54 40.55 124 64 124z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.39 90.94l20.02-15.53c-1.2-3.61-1.86-7.44-1.86-11.41 0-3.97.66-7.8 1.86-11.41V37.06H10.39C6.31 45.16 4 54.31 4 64c0 9.69 2.31 18.84 6.39 26.94z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64 27.86c8.82 0 16.72 3.04 22.95 8.97l17.2-17.2C93.75 9.95 80.18 4 64 4 40.55 4 20.26 17.46 10.39 37.06l20.02 15.53C35.14 38.4 48.39 27.86 64 27.86z",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 64V4h120v120H4z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.f79c5c1b8cf7b4fc887b565716144e88.svg";
export { ForwardRef as ReactComponent };